let elements = [];
let offset = 0;

function isElementInView(element) {
    let rect = element.getBoundingClientRect();
    let innerHeight = window.innerHeight;

    // The top is in view: the top is more than 0 and less than the window height (the top of the element is in view)
    let topIsInView =
        rect.top + offset >= 0 && rect.top + offset <= innerHeight;
    // The bottom is in view: bottom position is greater than 0 and greater than the window height
    let bottomIsInView =
        rect.bottom + offset >= 0 && rect.bottom + offset <= innerHeight;
    // The top is above the viewport and the bottom is below the viewport
    let topIsAboveAndBottomIsBelow =
        rect.top + offset < 0 && rect.bottom + offset > innerHeight;

    //Return true if any of the following conditions are met:
    return topIsInView || bottomIsInView || topIsAboveAndBottomIsBelow;
}

function enter(element) {
    element.classList.add("has-entered");
}

function scrollEntranceUpdate() {
    for (let i = 0; i < elements.length; i++) {
        if (isElementInView(elements[i])) {
            enter(elements[i]);
        }
    }
}

function scrollEntrance(heightOffset) {
    //Store the elements to be animated
    elements = document.querySelectorAll("[data-entrance]");
    if (typeof heightOffset == "number") {
        offset = typeheightOffset;
    }

    // Set up the initial styles on each element, and check if they should be visible
    for (let i = 0; i < elements.length; i++) {
        if (isElementInView(elements[i])) {
            let item = elements[i];
            // If the elements are in view when loaded, animate in after load
            enter(item);
        }
    }
}

export { scrollEntrance, scrollEntranceUpdate };
